/**
 * PrivacyPage — Política de Privacidad (Sprint 14 S14.2 — R1 GDPR).
 *
 * Ruta PÚBLICA /privacy (accesible sin login: debe poder leerse antes de
 * registrarse). Contenido verbatim de src/content/legal.ts.
 */
import { LegalDocument } from "@/components/legal/LegalDocument";
import { PRIVACY_MARKDOWN } from "@/content/legal";

export function PrivacyPage() {
  return <LegalDocument source={PRIVACY_MARKDOWN} testId="privacy-page" />;
}
